import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';


export interface DialogData {
  titel: string;
  text: string;
}

@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.css'],
    standalone: false
})
export class DialogComponent implements OnInit {

  constructor(private dialogRef:MatDialogRef<DialogComponent>,

              @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  closeDialog() {
    this.dialogRef.close();
  }


  ngOnInit() {
  }

}
